var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1389 19.6863H23.1271C24.991 19.6863 26.5019 18.1736 26.5019 16.32V8.33332C26.5019 6.47417 24.9854 4.96704 23.1271 4.96704H11.1389C9.27509 4.96704 7.76416 6.47967 7.76416 8.33332V16.32C7.76416 18.1736 9.27509 19.6863 11.1389 19.6863ZM8.59131 8.33332C8.59131 6.9307 9.73278 5.79211 11.1389 5.79211H23.1271C24.5333 5.79211 25.6747 6.9307 25.6747 8.33332V16.32C25.6747 17.7226 24.5333 18.8612 23.1271 18.8612H11.1389C9.73278 18.8612 8.59131 17.7226 8.59131 16.32V8.33332Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01091 3.61931C3.40378 3.61931 3.72226 3.30163 3.72226 2.90975C3.72226 2.51788 3.40378 2.2002 3.01091 2.2002C2.61804 2.2002 2.29956 2.51788 2.29956 2.90975C2.29956 3.30163 2.61804 3.61931 3.01091 3.61931Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2663 3.61931C31.6591 3.61931 31.9776 3.30163 31.9776 2.90975C31.9776 2.51788 31.6591 2.2002 31.2663 2.2002C30.8734 2.2002 30.5549 2.51788 30.5549 2.90975C30.5549 3.30163 30.8734 3.61931 31.2663 3.61931Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01091 22.3649C3.40378 22.3649 3.72226 22.0472 3.72226 21.6554C3.72226 21.2635 3.40378 20.9458 3.01091 20.9458C2.61804 20.9458 2.29956 21.2635 2.29956 21.6554C2.29956 22.0472 2.61804 22.3649 3.01091 22.3649Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2663 22.3649C31.6591 22.3649 31.9776 22.0472 31.9776 21.6554C31.9776 21.2635 31.6591 20.9458 31.2663 20.9458C30.8734 20.9458 30.5549 21.2635 30.5549 21.6554C30.5549 22.0472 30.8734 22.3649 31.2663 22.3649Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V4.7634V19.4826V24.6421H34.2661V0H0ZM0.827151 16.0393V13.9822H3.18178V16.0393H0.827151ZM3.18178 16.8644V18.6631H0.827151V16.8644H3.18178ZM0.827151 13.1571V11.0999H3.18178V13.1571H0.827151ZM0.827151 10.2694V8.21219H3.18178V10.2694H0.827151ZM0.827151 7.38712V5.58847H3.18178V7.38712H0.827151ZM33.439 23.8225H0.827151V19.4881H4.00893V4.7634H0.827151V0.825069H33.439V23.8225Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.118fef8ef7ca402ad071c9ebfed90fd1.svg";
export { ForwardRef as ReactComponent };